import {useForm, Controller} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
	Button,
	Loading
} from "~/components";
import {Col, notification, Row} from "antd";
import {
	InputField,
} from "~/components/Forms";
import {useEffect, useState} from "react";
import {apiError, handleRequest} from "../../../../utils";
import {serviceApi} from "../../../../api";

function ServiceFormNsEdit({item, onHandleSubmit}) {

	const [loading, setLoading] = useState(true)

	const initialValues = {
		ns1: item?.ns1,
		ns2: item?.ns2,
		zoneId: item?.zoneId,
	}

	const loadNameServer = async () =>
	{
		if(!item?.ns1)
		{
			setLoading(true)

			let [error, response] = await handleRequest(serviceApi.getNameserver(item.id));

			let message = apiError(`Lấy thông tin name server cho tên miền thất bại`, error, response);

			if(!message)
			{
				initialValues.ns1 = response.data.ns1;

				initialValues.ns2 = response.data.ns2;

				initialValues.zoneId = response.data.zoneId;

				reset(initialValues);
			}

			setLoading(false)
		}
	}

	const validationSchema = Yup.object().shape({
		ns1: Yup.string().required('Bạn chưa điền name server 1'),
		ns2: Yup.string().required('Bạn chưa điền name server 2'),
		zoneId: Yup.string().required('Bạn chưa điền zone id'),
	})

	const { control, handleSubmit, formState: { isSubmitting, errors }, reset} = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	useEffect(() => {
		loadNameServer().then(
			() => {
				console.log('load name server success');
			},
			() => {
				console.log('load name server fail');
			}
		);
	}, [item.id])

	const onSubmit = async (data) => {
		await onHandleSubmit(data, item);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{(isSubmitting || loading) && <Loading/>}
			<p className="heading">Thông tin </p>
			<Row gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="ns1" render={({ field }) => (
						<InputField type="text" label="Name Server 1" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="ns2" render={({ field }) => (
						<InputField type="text" label="Name Server 2" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={24}>
					<Controller control={control} name="zoneId" render={({field}) => (
						<InputField label="Zone Id" errors={errors} {...field}/>
					)}/>
				</Col>
			</Row>
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">Cập nhật</Button>
			</div>
		</form>
	)
}

export default ServiceFormNsEdit;